export default "__VITE_ASSET__DrlRRRMO__"